const cache = new Map<string, HTMLImageElement>();

export function getFruitImage(src: string): HTMLImageElement {
  let im = cache.get(src);
  if (!im) {
    im = new Image();
    im.src = src;
    cache.set(src, im);
  }
  return im;
}

export function preloadFruitImages(urls: readonly string[]): void {
  for (const u of urls) {
    getFruitImage(u);
  }
}
